import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { ApiValidationError } from 'contracts/Common';

const { Types, Creators } = createActions(
  {
    request: ['postData', 'onSuccess', 'onFailure'],
    success: [],
    failure: ['errorMessage', 'validationErrors'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'CREATE_WAREHOUSE_SCHEDULING_RESTRICTION_',
  }
);

export interface CreateWarehouseSchedulingRestrictionState {
  loading: boolean;
  errorMessage: string | null;
  validationErrors: ApiValidationError[];
}

export interface CreateWarehouseSchedulingRestrictionRequestAction {
  postData: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface FailureAction {
  errorMessage: string;
  validationErrors?: ApiValidationError[];
}

const INITIAL_STATE: CreateWarehouseSchedulingRestrictionState = {
  loading: false,
  errorMessage: null,
  validationErrors: [],
};

const request = (state: CreateWarehouseSchedulingRestrictionState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
    validationErrors: { $set: [] },
  });

const success = (state: CreateWarehouseSchedulingRestrictionState) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (state: CreateWarehouseSchedulingRestrictionState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
    validationErrors: { $set: action.validationErrors || [] },
  });

const softReset = (state: CreateWarehouseSchedulingRestrictionState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const createWarehouseSchedulingRestriction = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const CreateWarehouseSchedulingRestrictionTypes = Types;
export const CreateWarehouseSchedulingRestrictionActions = Creators;
